import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { makeStyles } from 'src/makeStyles';
import NextLink from '../NextLink';

const useStyles = makeStyles()(theme => ({
  countriesList: {
    columnCount: 6,
    listStyleType: 'none',
    padding: 0,
    paddingTop: '2rem',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      columnCount: 2,
    },
    '& > li': {
      width: 140,
      paddingRight: 10,
      lineHeight: 1.9,
    },
    '& a': {
      wordWrap: 'break-word',
      minWidth: 140,
      [theme.breakpoints.down('md')]: {
        wordWrap: 'normal',
      },
    },
  },
}));

const CountriesList = ({ countries, linkProps, path, as, years }) => {
  const { classes, cx } = useStyles();
  return (
    <ul className={classes.countriesList}>
      {countries &&
        countries.map(country => {
          const props = typeof linkProps === 'function' ? linkProps(country, path, as, years) : {};
          return (
            <li key={country.slug}>
              <NextLink {...props}>{get(country, 'name')}</NextLink>
            </li>
          );
        })}
    </ul>
  );
};

CountriesList.propTypes = {
  countries: PropTypes.array,
  linkProps: PropTypes.func,
  path: PropTypes.string,
  as: PropTypes.string,
  years: PropTypes.number,
};

CountriesList.defaultProps = {
  linkProps: (country, path, as, years) => ({
    href: `${path}`,
    as: years ? `${as}/${get(country, 'slug')}?years=${years}` : `${as}/${get(country, 'slug')}`,
  }),
};

export default CountriesList;
